import { Tooltip } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info';

/**
 * Component to streamline the tooltip styling in the Ring of Fire app.
 * @param {Object} props 
 * @param {React.ReactNode} props.tooltipText Content to display in the tooltip
 * @returns {JSX.Element}
 */

export default function RofTooltip({ tooltipText }) {
    const tooltipColor = 'lightgreen'

    return (
        <Tooltip
            title={
                <h2 style={{ color: tooltipColor }}>
                    {tooltipText}
                </h2>
            }
        >
            <InfoIcon sx={{ width: 26 }} />
        </Tooltip>
    )
}

/** This component is the same as RoFTooltip.js, it just has no info button as to be wrapped around a button
 * @param {Object} props
 * @param {string} props.tooltipText String value to render inside of the tooltip
 * @param {React.ReactNode} props.children The tooltip wraps what is passed in. i.e. a button component
 * @returns {JSX.Element}
 */
export function RofButtonTooltip({ tooltipText, children }) {
    const tooltipColor = 'lightgreen'

    return (
        <Tooltip
            title={
                <h2 style={{ color: tooltipColor }}>
                    {tooltipText}
                </h2>
            }
        >
            {children}
        </Tooltip>
    )
}